"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _CustomInput = require("./components/CustomInput");
var _CustomSlider = require("./components/CustomSlider");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    fieldContainer: _defineProperty({
      paddingTop: '15px !important',
      paddingBottom: '15px !important'
    }, theme.breakpoints.up('md'), {
      alignItems: 'center',
      paddingTop: '20px !important',
      paddingBottom: '20px !important'
    }),
    sliderContainer: {
      paddingLeft: 18,
      paddingRight: 18
    },
    inputsContainer: _defineProperty({
      marginTop: 15,
      marginBottom: 15
    }, theme.breakpoints.up('md'), {
      marginTop: 'inherit',
      marginBottom: 'inherit'
    })
  };
});
var RangeField = function RangeField(props) {
  var field = props.field,
    form = props.form,
    label = props.label,
    _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    _props$max = props.max,
    max = _props$max === void 0 ? 1000 : _props$max,
    _props$step = props.step,
    step = _props$step === void 0 ? 0.1 : _props$step;
  var _useState = (0, _react.useState)(props.value || [min, max]),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var classes = useStyle();
  (0, _react.useEffect)(function () {
    var delayDebounceFn = setTimeout(function () {
      form.setFieldValue(field.name, value);
    }, 700);
    return function () {
      return clearTimeout(delayDebounceFn);
    };
  }, [value, field.name]);
  var handlePriceChange = function handlePriceChange(event, newValue) {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (newValue[0] < min) {
      newValue[0] = min;
    }
    if (newValue[1] > max) {
      newValue[1] = max;
    }
    setValue(newValue);
  };
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 0,
    item: true,
    xs: 12,
    md: 12,
    className: classes.fieldContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, label)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    md: 9,
    className: classes.inputsContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_CustomInput.CustomInput, {
    type: "number",
    onEndTyping: function onEndTyping(event) {
      return handlePriceChange(event, [parseFloat(event.target.value || min), value[1]]);
    },
    value: value[0]
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 5,
    md: 8,
    className: classes.sliderContainer
  }, /*#__PURE__*/_react.default.createElement(_CustomSlider.CustomSlider, {
    ThumbComponent: _CustomSlider.CustomSliderThumb,
    getAriaLabel: function getAriaLabel(index) {
      return index === 0 ? 'Minimum' : 'Maximum';
    },
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: handlePriceChange,
    disableSwap: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_CustomInput.CustomInput, {
    type: "number",
    onEndTyping: function onEndTyping(event) {
      return handlePriceChange(event, [value[0], parseFloat(event.target.value || max)]);
    },
    value: value[1]
  }))));
};
exports.RangeField = RangeField;